import {Box, Typography} from '@mui/material'
import React from 'react'
import {useTranslation} from "react-i18next";

export default function DataLoading({text = "Loading"}) {
    const {t} = useTranslation();
    return (
        <Box
            style={{
                position: "fixed", // Full screen overlay
                top: 0,
                left: 0,
                width: "100vw", // Full viewport width
                height: "100vh", // Full viewport height
                backgroundColor: "rgba(0, 0, 0, 0.5)", // Transparent black background
                display: "flex",
                flexDirection: "column", // Column layout for spinner & text
                justifyContent: "center",
                alignItems: "center",
                zIndex: 2000, // Keep it on top
            }}
        >
            {/* Spinner */}
            <Box
                style={{
                    width: "40px", // Spinner size
                    height: "40px",
                    border: "6px solid white", // White spinner color
                    borderTop: "6px solid transparent", // For spinning effect
                    borderRadius: "50%",
                    animation: "spin 1s linear infinite",
                }}
            ></Box>

            {/* Text below the spinner */}
            <Typography
                variant="h6"
                style={{
                    marginTop: "30px", // Increased space between spinner and text
                    color: "white", // White text color for visibility
                }}
            >
                {/* Dynamic text from the `t` function */}
                {t(text)}
            </Typography>

            {/* CSS for animation */}
            <style>
                {`
          @keyframes spin {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }
        `}
            </style>
        </Box>
    )
}
